import { ModalOpenAction, ModalActionTypes } from 'redux/modal/modalActions';

const isModalOpenAction = (action: any): action is ModalOpenAction =>
  action?.type === ModalActionTypes.OPEN;

export default isModalOpenAction;
